export enum AdminModalName {
  DeleteEvent = 'delete_event',
  DeletePage = 'delete_page',
  DeletePlace = 'delete_place',
  DiscardPageDraft = 'discard_page_draft',
}
